// This expects the json object that is returned from the expansion on provider.onboardingStatus
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();export const hasCreatedGroup = (onboardingStatus) => {
  return (
    (onboardingStatus?.groupComplete ?? false) ||
    (onboardingStatus?.groupPendingPublication ?? false)
  )
}

// This expects the json object that is returned from the expansion on provider.onboardingStatus
export const hasCreatedCohort = (onboardingStatus) => {
  return onboardingStatus?.cohortComplete ?? false
}

// This expects the json object that is returned from the expansion on provider.onboardingStatus
export const hasCreatedProfile = (onboardingStatus) => {
  return (
    (onboardingStatus?.profileComplete ?? false) ||
    (onboardingStatus?.profilePendingPublication ?? false)
  )
}

// This expects the json object that is returned from the expansion on provider.onboardingStatus
export const hasSetupPayment = (onboardingStatus) => {
  return onboardingStatus?.paymentTransactOffPlatform ||
    (onboardingStatus?.paymentConnectedAccountComplete &&
      onboardingStatus?.paymentExternalAccountComplete)
    ? true
    : false
}

// This expects the json object that is returned from the expansion on provider.onboardingStatus
// this looks at if the items have been submitted for review. Not if they have been fully approved

export const areAllOnboardingStepsComplete = (onboardingStatus) => {
  //   if there are no false values in the array, then all steps are complete
  return ![
    hasCreatedGroup(onboardingStatus),
    hasCreatedCohort(onboardingStatus),
    hasCreatedProfile(onboardingStatus),
  ].includes(false)
}

// This function returns the count of incomplete onboarding steps
export const countRemainingOnboardingSteps = (onboardingStatus) => {
  if (onboardingStatus === null) {
    return 0
  }
  const steps = [
    hasCreatedGroup(onboardingStatus),
    hasCreatedCohort(onboardingStatus),
    hasCreatedProfile(onboardingStatus),
  ]

  // Filter the steps to count how many are still false (incomplete)
  const remainingStepsCount = steps.filter((step) => step === false).length

  return remainingStepsCount
}

export const areAllOnboardingStepsCompleteOrRecentlySignedCertsAndDocuments = ({
  onboardingStatus,
}) => {
  //   if there are no false values in the array, then all steps are complete
  return ![
    hasCreatedGroup(onboardingStatus),
    hasCreatedCohort(onboardingStatus),
    hasCreatedProfile(onboardingStatus),
  ].includes(false)
}

// This expects the json object that is returned from the expansion on provider.onboardingStatus
export const areNoOnboardingStepsComplete = (onboardingStatus) => {
  //   if there are no true values in the array, then no steps are complete

  return ![
    hasCreatedGroup(onboardingStatus),
    hasCreatedCohort(onboardingStatus),
    hasCreatedProfile(onboardingStatus),
  ].includes(true)
}
